module.exports = __webpack_public_path__ + "img/download.3383916e.png";